const fr = {
    error: {
        description: {
            intro: 'La page ou le fichier que vous avez demandé est introuvable sur ce server. SVP',
            contact: 'contactez le support',
            finish: 'et nous serons heureux de vous aider.',
        },
    },
    system: {
        announcement: 'Annonce de MFC: ',
    },
}

export default fr
